// extracted by mini-css-extract-plugin
export default {"iconCard":"icon-card-module--iconCard--kaZAv","icon":"icon-card-module--icon--Eqw+2","title":"icon-card-module--title--DhxDq","body":"icon-card-module--body--eJ4ny"};